import React from 'react';
import { PageLayout } from '../components/Layout/PageLayout';
import { PageConfig } from '../config/pageConfigs';
import HeroSection from '../sections/Hero/Hero';
import ContentSection from '../sections/Content/Content';
import FeatureListingSection from '../sections/Listing/Feature&Benefit/Feature&Benefit';
import PartnerListingSection from '../sections/Listing/Partner/Partner';
import ServiceListingSection from '../sections/Listing/Service/Service';
import RequestContactForm from '../sections/Form/RequestContact/RequestContact';
import SubmitaNewSpotSection from '../sections/Form/SubmitaNewSpot/SubmitaNewSpot';
import CategorySection from '../sections/Category/Categories';

// Map section types to their components
const sectionComponents = {
  hero: HeroSection,
  content: ContentSection,
  featureListing: FeatureListingSection,
  partnerListing: PartnerListingSection,
  serviceListing: ServiceListingSection,
  requestContact: RequestContactForm,
  submitSpot: SubmitaNewSpotSection,
  categories: CategorySection,
};

interface GenericPageProps {
  config: PageConfig;
}

/**
 * GenericPage renders pages dynamically based on configuration.
 * This eliminates the need for separate page component files.
 * All page structure and content is driven by data from pageConfigs.ts
 */
export const GenericPage: React.FC<GenericPageProps> = ({ config }) => {
  return (
    <PageLayout navType={config.navType}>
      {config.sections.map((section, index) => {
        const Component = sectionComponents[section.type];
        
        if (!Component) {
          console.warn(`Unknown section type: ${section.type}`);
          return null;
        }

        return <Component key={index} {...section.props} />;
      })}
    </PageLayout>
  );
};

export default GenericPage;
